<template>
  <VueMarkdown
    :source="content"
    :class="[
      base.content,
      type[font],
      type[weight],
      type[typeScaleClass(size)]
    ]"
  />
</template>

<script>
import { styleHelpers } from "./mixins/helpers";
import VueMarkdown from "vue-markdown";

export default {
  name: "BaseBodyText",
  components: {
    VueMarkdown
  },
  mixins: [styleHelpers],
  props: {
    content: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "epsilon"
    },
    font: {
      type: String,
      default: "body",
      validator: function(value) {
        return ["body", "display"].indexOf(value) !== -1;
      }
    },
    weight: {
      type: String,
      validator: function(value) {
        return ["bold", "light"].indexOf(value) !== -1;
      }
    }
  }
};
</script>

<style src="styles/type.scss" lang="scss" module="type"></style>

<style lang="scss" module="base">
@import "~styleConfig/scale";
@import "~styleConfig/color";
@import "~styleConfig/borders";
@import "~styleConfig/type";
@import "~styleConfig/spacing";

$gutter: 0.7em; // eta on scale

.content {
  p {
    margin-bottom: 0;
    margin-top: 0;
  }

  em {
    @include font("body", $style: "italic");

    strong {
      @include font("body", $weight: "bold");
    }
  }

  strong {
    @include font("body", $weight: "bold");

    em {
      @include font("body", $style: "italic");
    }
  }

  * + *,
  p + p {
    margin-top: $gutter;
  }

  li + li {
    margin-top: $gutter;
  }

  ul,
  ol {
    padding-left: 1.2em;
  }

  // global class names generated by markdown
  // -> these are overrides to help match our own styles
  :global {
    // hr element above footnotes, generated by markdown
    // -> style to look like secondary border
    .footnotes-sep {
      border: none;
      height: border-w("thin");
      background-color: border("light");
      margin: 1.44em 0; // delta on scale
    }

    .footnotes {
      font-size: scale-type("zeta");
      color: color("midtone");
    }
  }

  @media print {
    // display urls of external links
    a {
      color: #000;

      &[href^="http://"],
      &[href^="https://"] {
        word-wrap: break-word;

        &:after {
          content: " (" attr(href) ")";
          font-size: 0.8em;
        }
      }
    }
  }
}
</style>
